import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'privateNumber',
})
export class PrivateNumberPipe implements PipeTransform {
  transform(value: string | number, available: number = 4): string {
    const number: string = typeof value === 'string' ? value : value?.toString();
    const numbers: string[] = number?.split('');
    const availableNumbers: number = number?.length - available;
    const privateNumber: string =
      typeof value === 'string' ? value?.substring(value.length - 4) : '';

    return `*${privateNumber}`;
  }
}
